import React from "react";
import "./policy.css";

const TermsOfService = () => {
	return (
		<div className="policy-container">
			<h1>Terms of Service</h1>
			<p className="last-updated">Last Updated: March 2026</p>
			
			<section>
				<h2>1. Acceptance of Terms</h2>
				<p>
					By using our Refresh Inn Touchwood platform, you agree to these terms when browsing,
					booking, or staying at listed properties.
				</p>
			</section>
			
			<section>
				<h2>2. Booking & Payments</h2>
				<ul>
					<li>All bookings are subject to availability</li>
					<li>Prices are listed per night unless stated otherwise</li>
					<li>Payments must be completed to confirm your booking</li>
				</ul>
			</section>
			
			<section>
				<h2>3. Guest Responsibilities</h2>
				<ul>
					<li>Respect the property and local culture</li>
					<li>Follow house rules provided by the host</li>
					<li>Avoid damage, illegal activities, or disturbances</li>
				</ul>
			</section>
			
			<section>
				<h2>4. Cancellation Policy</h2>
				<p>
					Cancellation terms may vary depending on the property. Please review
					the specific listing before booking.
				</p>
			</section>
			
			<section>
				<h2>5. Host Responsibility</h2>
				<p>
					Hosts are responsible for providing accurate property details and a
					safe, clean stay experience.
				</p>
			</section>
			
			<section>
				<h2>6. Liability</h2>
				<p>
					We act as a platform connecting guests and hosts. We are not liable
					for issues arising during the stay but will assist in resolution where
					possible.
				</p>
			</section>
			
			<section>
				<h2>7. Changes to Terms</h2>
				<p>
					We may update these terms at any time. Continued use of the platform
					means acceptance of updated terms.
				</p>
			</section>
			
			<section>
				<h2>8. Contact</h2>
				<p>Email: support@yourhomestay.com</p>
			</section>
		</div>
	);
};

export default TermsOfService;